var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChannelSeparation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 305.72 200.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#231f20;opacity:0.2;}.cls-110,.cls-111,.cls-121,.cls-2,.cls-22,.cls-37,.cls-64,.cls-66,.cls-78{mix-blend-mode:multiply;}.cls-3{fill:url(#New_Gradient_Swatch_copy_36);}.cls-4{fill:url(#New_Gradient_Swatch_copy_36-2);}.cls-5{fill:url(#New_Gradient_Swatch_copy_36-3);}.cls-6{fill:url(#New_Gradient_Swatch_copy_36-4);}.cls-7{fill:url(#New_Gradient_Swatch_copy_36-5);}.cls-100,.cls-103,.cls-106,.cls-109,.cls-113,.cls-116,.cls-120,.cls-15,.cls-36,.cls-39,.cls-43,.cls-46,.cls-48,.cls-51,.cls-54,.cls-58,.cls-61,.cls-65,.cls-69,.cls-73,.cls-77,.cls-8,.cls-80,.cls-83,.cls-87,.cls-89,.cls-92,.cls-94,.cls-97{mix-blend-mode:color-dodge;}.cls-9{fill:url(#Radial_Gradient_1);}.cls-10{fill:url(#Radial_Gradient_1-2);}.cls-11{fill:url(#linear-gradient);}.cls-12{fill:url(#linear-gradient-2);}.cls-13{fill:url(#New_Gradient_Swatch_copy_25);}.cls-14{fill:url(#New_Gradient_Swatch_copy_25-2);}.cls-15{fill:url(#linear-gradient-3);}.cls-16{fill:url(#linear-gradient-4);}.cls-17{fill:#25054d;}.cls-18{fill:#45108a;}.cls-19{fill:#2af6ff;}.cls-20{fill:#4b61b8;}.cls-21{fill:url(#New_Gradient_Swatch_copy_26);}.cls-22{fill:#b086cc;}.cls-23{fill:#9122eb;}.cls-23,.cls-24,.cls-26,.cls-35{mix-blend-mode:screen;}.cls-24{opacity:0.7;}.cls-25{fill:#3c0862;}.cls-27{fill:#7c1dc9;}.cls-28{fill:url(#New_Gradient_Swatch_copy_57);}.cls-29{fill:url(#New_Gradient_Swatch_copy_57-2);}.cls-30{fill:url(#New_Gradient_Swatch_copy_57-3);}.cls-31{fill:url(#linear-gradient-5);}.cls-32{fill:url(#New_Gradient_Swatch_copy_10);}.cls-33{fill:url(#linear-gradient-6);}.cls-34{fill:url(#linear-gradient-7);}.cls-35{fill:#e6e7e8;}.cls-36{fill:url(#Radial_Gradient_1-3);}.cls-37{opacity:0.1;}.cls-38{fill:url(#linear-gradient-8);}.cls-39{fill:url(#radial-gradient);}.cls-40{fill:url(#radial-gradient-2);}.cls-41{fill:url(#radial-gradient-3);}.cls-42{fill:url(#linear-gradient-9);}.cls-43{fill:url(#radial-gradient-4);}.cls-44{fill:url(#radial-gradient-5);}.cls-45{fill:url(#linear-gradient-10);}.cls-46{fill:url(#radial-gradient-6);}.cls-47{fill:url(#linear-gradient-11);}.cls-48{fill:url(#radial-gradient-7);}.cls-49{fill:url(#radial-gradient-8);}.cls-50{fill:url(#linear-gradient-12);}.cls-51{fill:url(#radial-gradient-9);}.cls-52{fill:url(#radial-gradient-10);}.cls-53{fill:url(#linear-gradient-13);}.cls-54{fill:url(#radial-gradient-11);}.cls-55{fill:url(#radial-gradient-12);}.cls-56{fill:url(#linear-gradient-14);}.cls-57{fill:url(#radial-gradient-13);}.cls-58{fill:url(#radial-gradient-14);}.cls-59{fill:url(#radial-gradient-15);}.cls-60{fill:url(#linear-gradient-15);}.cls-61{fill:url(#radial-gradient-16);}.cls-62{fill:url(#linear-gradient-16);}.cls-63{fill:url(#radial-gradient-17);}.cls-64{fill:url(#linear-gradient-17);}.cls-65{fill:url(#radial-gradient-18);}.cls-66{fill:url(#linear-gradient-18);}.cls-67{fill:url(#radial-gradient-19);}.cls-68{fill:url(#linear-gradient-19);}.cls-69{fill:url(#radial-gradient-20);}.cls-70{fill:url(#radial-gradient-21);}.cls-71{fill:url(#radial-gradient-22);}.cls-72{fill:url(#linear-gradient-20);}.cls-73{fill:url(#radial-gradient-23);}.cls-74{fill:url(#radial-gradient-24);}.cls-75{fill:url(#radial-gradient-25);}.cls-76{fill:url(#linear-gradient-21);}.cls-77{fill:url(#radial-gradient-26);}.cls-78{fill:url(#linear-gradient-22);}.cls-79{fill:url(#linear-gradient-23);}.cls-80{fill:url(#radial-gradient-27);}.cls-81{fill:url(#radial-gradient-28);}.cls-82{fill:url(#linear-gradient-24);}.cls-149,.cls-83,.cls-87{opacity:0.5;}.cls-83{fill:url(#radial-gradient-29);}.cls-84{fill:url(#radial-gradient-30);}.cls-85{fill:url(#radial-gradient-31);}.cls-86{fill:url(#linear-gradient-25);}.cls-87{fill:url(#radial-gradient-32);}.cls-88{fill:url(#linear-gradient-26);}.cls-89{fill:url(#radial-gradient-33);}.cls-90{fill:url(#linear-gradient-27);}.cls-91{fill:url(#linear-gradient-28);}.cls-92{fill:url(#radial-gradient-34);}.cls-93{fill:url(#linear-gradient-29);}.cls-94{fill:url(#radial-gradient-35);}.cls-95{fill:url(#linear-gradient-30);}.cls-96{fill:url(#linear-gradient-31);}.cls-97{fill:url(#radial-gradient-36);}.cls-98{fill:url(#radial-gradient-37);}.cls-99{fill:url(#linear-gradient-32);}.cls-100{fill:url(#radial-gradient-38);}.cls-101{fill:url(#linear-gradient-33);}.cls-102{fill:url(#radial-gradient-39);}.cls-103{fill:url(#radial-gradient-40);}.cls-104{fill:url(#radial-gradient-41);}.cls-105{fill:url(#linear-gradient-34);}.cls-106{fill:url(#radial-gradient-42);}.cls-107{fill:url(#radial-gradient-43);}.cls-108{fill:url(#radial-gradient-44);}.cls-109{fill:url(#radial-gradient-45);}.cls-110{fill:url(#linear-gradient-35);}.cls-111{fill:url(#linear-gradient-36);}.cls-112{fill:url(#linear-gradient-37);}.cls-113{fill:url(#radial-gradient-46);}.cls-114{fill:url(#radial-gradient-47);}.cls-115{fill:url(#linear-gradient-38);}.cls-116{fill:url(#radial-gradient-48);}.cls-117{fill:url(#linear-gradient-39);}.cls-118{fill:url(#radial-gradient-49);}.cls-119{fill:url(#linear-gradient-40);}.cls-120{fill:url(#radial-gradient-50);}.cls-121{fill:url(#linear-gradient-41);}.cls-122{fill:url(#New_Gradient_Swatch_copy_10-2);}.cls-123{fill:url(#New_Gradient_Swatch_copy_10-3);}.cls-124{fill:url(#New_Gradient_Swatch_copy_10-4);}.cls-125{fill:url(#linear-gradient-42);}.cls-126{fill:url(#New_Gradient_Swatch_copy_10-5);}.cls-127{fill:url(#New_Gradient_Swatch_copy_10-6);}.cls-128{fill:url(#linear-gradient-43);}.cls-129{fill:url(#linear-gradient-44);}.cls-130{fill:url(#New_Gradient_Swatch_copy_10-7);}.cls-131{fill:#858098;}.cls-132{fill:url(#linear-gradient-45);}.cls-133{fill:url(#New_Gradient_Swatch_copy_10-8);}.cls-134{fill:url(#linear-gradient-46);}.cls-135{fill:url(#New_Gradient_Swatch_copy_10-9);}.cls-136{fill:url(#linear-gradient-47);}.cls-137{fill:url(#New_Gradient_Swatch_copy_10-10);}.cls-138{fill:url(#linear-gradient-48);}.cls-139{fill:url(#New_Gradient_Swatch_copy_10-11);}.cls-140{fill:url(#linear-gradient-49);}.cls-141{fill:url(#New_Gradient_Swatch_copy_10-12);}.cls-142{fill:url(#linear-gradient-50);}.cls-143{fill:url(#New_Gradient_Swatch_copy_10-13);}.cls-144{fill:url(#linear-gradient-51);}.cls-145{fill:url(#New_Gradient_Swatch_copy_10-14);}.cls-146{fill:url(#linear-gradient-52);}.cls-147{fill:url(#New_Gradient_Swatch_copy_10-15);}.cls-148{fill:url(#linear-gradient-53);}.cls-150{fill:#fff;opacity:0.15;}.cls-151{fill:url(#New_Gradient_Swatch_copy_10-16);}.cls-152{fill:url(#New_Gradient_Swatch_copy_10-17);}.cls-153{fill:url(#New_Gradient_Swatch_copy_10-18);}.cls-154{fill:url(#New_Gradient_Swatch_copy_10-19);}.cls-155{fill:url(#New_Gradient_Swatch_copy_10-20);}.cls-156{fill:url(#linear-gradient-54);}.cls-157{fill:url(#linear-gradient-55);}.cls-158{fill:url(#linear-gradient-56);}.cls-159{fill:url(#linear-gradient-57);}.cls-160{fill:url(#linear-gradient-58);}.cls-161{fill:url(#linear-gradient-59);}.cls-162{fill:url(#linear-gradient-60);}.cls-163{fill:url(#linear-gradient-61);}.cls-164,.cls-165{mix-blend-mode:overlay;}.cls-164{fill:url(#linear-gradient-62);}.cls-165{fill:url(#linear-gradient-63);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36",
    x1: 517.03,
    y1: 222.77,
    x2: 650.96,
    y2: 145.24,
    gradientTransform: "translate(-315.63 -118.69) rotate(-3.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36-2",
    x1: 601.14,
    y1: 191.63,
    x2: 729.24,
    y2: 218.44,
    xlinkHref: "#New_Gradient_Swatch_copy_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36-3",
    x1: 532.29,
    y1: 168.24,
    x2: 510.33,
    y2: 202.62,
    xlinkHref: "#New_Gradient_Swatch_copy_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36-4",
    x1: 590.41,
    y1: 188.86,
    x2: 577.01,
    y2: 225.43,
    xlinkHref: "#New_Gradient_Swatch_copy_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_36-5",
    x1: 553.21,
    y1: 109.37,
    x2: 527.71,
    y2: 213.3,
    xlinkHref: "#New_Gradient_Swatch_copy_36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1",
    cx: 502.58,
    cy: 175.74,
    r: 8.42,
    gradientTransform: "matrix(1.16, -0.08, 0.07, 1, -376.82, -115.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-2",
    cx: 510.63,
    cy: 200.98,
    r: 54.12,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 552.71,
    y1: 211.42,
    x2: 554.15,
    y2: 193.42,
    gradientTransform: "matrix(1.35, -0.35, 0.25, 0.97, -287.67, 207.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffec7e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 513.41,
    y1: 194.24,
    x2: 512.55,
    y2: 211.96,
    gradientTransform: "matrix(1.03, -0.4, 0.25, 0.65, -69.87, 274.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44ce1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#565de9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25",
    x1: 454.41,
    y1: 262.39,
    x2: 618.45,
    y2: 213.27,
    gradientTransform: "translate(-303.91 -155.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-2",
    x1: 298.84,
    y1: 282.31,
    x2: 514.88,
    y2: 233.88,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 464.66,
    y1: 322.81,
    x2: 389.39,
    y2: 242.46,
    gradientTransform: "translate(-303.91 -155.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b61b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#38498a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#273360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#19203e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0e1223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#06080f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 491.36,
    y1: 100.93,
    x2: 421.49,
    y2: 234.09,
    gradientTransform: "translate(-303.91 -155.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26",
    x1: 435.62,
    y1: 168.45,
    x2: 435.62,
    y2: 227.42,
    gradientTransform: "translate(-303.91 -155.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6e41d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4c9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_57",
    x1: 9926.55,
    y1: 204.45,
    x2: 9869.3,
    y2: 305.83,
    gradientTransform: "matrix(-1, 0, 0, 1, 10061.36, -155.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fac098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a142b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7926cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6165db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4c9ce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#32e1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_57-2",
    x1: 9923.52,
    y1: 207.98,
    x2: 9882.09,
    y2: 293.87,
    xlinkHref: "#New_Gradient_Swatch_copy_57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_57-3",
    x1: 9947.24,
    y1: 170.12,
    x2: 9881.42,
    y2: 297.82,
    xlinkHref: "#New_Gradient_Swatch_copy_57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 311.85,
    y1: 253.19,
    x2: 308.96,
    y2: 248.18,
    gradientTransform: "translate(64.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a5a2b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#b7b4c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9b98a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10",
    x1: 308.91,
    y1: 252.79,
    x2: 311.47,
    y2: 248.38,
    gradientTransform: "translate(233.39 -122) rotate(30.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 310.6,
    y1: 253.44,
    x2: 308.11,
    y2: 249.14,
    gradientTransform: "translate(64.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#4dc4de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#49cfde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#43e1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#43e2de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3dabc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3a91bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3b96bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ca0c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 307.87,
    y1: 253.21,
    x2: 310.06,
    y2: 249.43,
    gradientTransform: "translate(64.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1fc3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-3",
    cx: 309.45,
    cy: 251.28,
    r: 1.79,
    gradientTransform: "translate(64.23)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 4388.06,
    y1: 639.32,
    x2: 4380.18,
    y2: 642.28,
    gradientTransform: "matrix(-0.99, -0.12, -0.12, 0.99, 4915.99, 180.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#c8abda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#dac6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f7f2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f9f5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e9dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b395d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9c7dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8e6ec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9471c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 4426.71,
    cy: 585.24,
    r: 4.57,
    gradientTransform: "matrix(-0.94, -0.11, -0.11, 0.94, 4707.94, 244.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8c276c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#671d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#471437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2d0d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#190713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0b0308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#020102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 3269.93,
    cy: 261.83,
    r: 1.79,
    gradientTransform: "translate(-2781.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#364f87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1b2b69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12054e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 2981.73,
    cy: 589.89,
    r: 1.49,
    gradientTransform: "matrix(0.98, 0.18, -0.18, 0.98, -2334.85, -842.09)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 4497.57,
    y1: 584.14,
    x2: 4492.3,
    y2: 584.1,
    gradientTransform: "matrix(-0.98, -0.18, -0.18, 0.98, 5015.68, 525.2)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 5000.44,
    cy: 583.94,
    r: 4.24,
    gradientTransform: "matrix(-0.59, -0.11, -0.18, 0.98, 3565.99, 255.62)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 3118.89,
    cy: 418.81,
    r: 1.79,
    gradientTransform: "translate(-2575.91 -434.42) rotate(5.31)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 4362.36,
    y1: 415.08,
    x2: 4356.33,
    y2: 413.32,
    gradientTransform: "matrix(-1, -0.09, -0.09, 1, 4868.36, 257.24)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 5712.17,
    cy: 659.28,
    r: 3.03,
    gradientTransform: "matrix(-0.57, -0.05, 0.07, 1.2, 3678.1, -241.75)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 4220.54,
    y1: 318.79,
    x2: 4219.56,
    y2: 325.16,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 4220.58,
    cy: 8607.63,
    r: 4.64,
    gradientTransform: "matrix(-1, 0, 0, 0.5, 4694.81, -3983)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 3259.4,
    cy: 319.74,
    r: 1.79,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 4211.61,
    y1: 314.68,
    x2: 4213.02,
    y2: 321.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 4213.21,
    cy: 316.01,
    r: 2.31,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 3265.17,
    cy: 316.07,
    r: 1.79,
    gradientTransform: "translate(-3083.6 -155.96)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 4214.96,
    y1: 307.75,
    x2: 4208.5,
    y2: 306.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 4272.81,
    cy: -2792.1,
    r: 4.58,
    gradientTransform: "matrix(-0.89, 0, 0, 1.6, 4277.86, 4772.83)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 3263.22,
    cy: 299.01,
    r: 2.59,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 4218.16,
    y1: 286.96,
    x2: 4208.68,
    y2: 287.94,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 4240.59,
    cy: 250.35,
    r: 6.74,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e6d7f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d7bde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c4a4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#a17bc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#a37cc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ae84cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#ad84cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a57dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f79c8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 4242.9,
    cy: 250.76,
    r: 3.26,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 3234.7,
    cy: 256.33,
    r: 1.49,
    gradientTransform: "translate(-3083.6 -155.96)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 4234.29,
    y1: 260.61,
    x2: 4238.71,
    y2: 264.72,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 4960.82,
    cy: -326.04,
    r: 5.92,
    gradientTransform: "matrix(-0.78, -0.05, -0.04, 0.69, 4330.55, 734.92)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 4220.65,
    y1: 275.34,
    x2: 4208.63,
    y2: 276.14,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 4222.66,
    cy: 258.95,
    r: 19.27,
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 4213.66,
    y1: 264.86,
    x2: 4211.11,
    y2: 275.21,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 4218.73,
    cy: 259.18,
    r: 10.23,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 4217.98,
    y1: 274.32,
    x2: 4220.75,
    y2: 267.11,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 4221.91,
    cy: 268.02,
    r: 2.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 4221.16,
    y1: 311.77,
    x2: 4215.62,
    y2: 310.63,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 4247.08,
    cy: -3639.4,
    r: 4.35,
    gradientTransform: "matrix(-0.74, 0.06, 0.14, 1.9, 4153.46, 6988.09)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 3255.93,
    cy: 302.59,
    r: 2.28,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 3246.28,
    cy: 267.43,
    r: 1.79,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 4225.29,
    y1: 264.55,
    x2: 4225.73,
    y2: 271.21,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 4225.87,
    cy: 6028.29,
    r: 5.99,
    gradientTransform: "matrix(-1, 0, 0, 0.5, 4694.81, -2746.97)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 4219.2,
    cy: 250.74,
    r: 9.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 4218.73,
    cy: 248.4,
    r: 9.28,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e6d7f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d7bde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c4a4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#a17bc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f79c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 4224.48,
    y1: 290.1,
    x2: 4215.06,
    y2: 291.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 4694.81, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 4545.22,
    cy: -1326.62,
    r: 8.53,
    gradientTransform: "matrix(-0.61, -0.01, -0.02, 1.24, 3221.31, 1979.07)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 4214.85,
    y1: 248.69,
    x2: 4215.02,
    y2: 256.41,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 5114.24,
    y1: -3009.48,
    x2: 5107.81,
    y2: -3008.55,
    gradientTransform: "matrix(0.11, -0.99, 0.99, 0.11, 2799.11, 5661.83)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 5110.85,
    cy: -3007.89,
    r: 5.78,
    gradientTransform: "matrix(0.11, -0.99, 0.99, 0.11, 2799.11, 5661.83)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 6635.65,
    cy: -2245.12,
    r: 1.96,
    gradientTransform: "translate(4130.43 6156.68) rotate(-103.85)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -1009.05,
    y1: 1149.05,
    x2: -1007.86,
    y2: 1153.69,
    gradientTransform: "matrix(0.95, 0.32, -0.32, 0.95, 1677.89, -518.75)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: -953.87,
    cy: 189.05,
    r: 5.24,
    gradientTransform: "matrix(0.97, 0.23, -0.14, 0.59, 1310.5, 359.14)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 88.5,
    cy: 1109.16,
    r: 1.72,
    gradientTransform: "translate(509.11 -850) rotate(12.83)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 49.55,
    cy: 1550.99,
    r: 2.66,
    gradientTransform: "translate(818.32 -1230.18) rotate(19.73)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 345.52,
    y1: 246.07,
    x2: 342.88,
    y2: 250.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 22.91,
    cy: 294.05,
    r: 4.65,
    gradientTransform: "matrix(0.94, 0.1, -0.08, 0.71, 346.24, 35.4)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 342.63,
    y1: 298.11,
    x2: 332.27,
    y2: 307.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 339.03,
    cy: 301.53,
    r: 4.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 336.24,
    y1: 292.47,
    x2: 333.25,
    y2: 292.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 339.73,
    y1: 292.51,
    x2: 331.74,
    y2: 290.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: -1868.26,
    cy: -2468.91,
    r: 5,
    gradientTransform: "matrix(0.61, 0.04, -0.1, 1.54, 1233.15, 4165.81)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 334.2,
    y1: 305.32,
    x2: 324.46,
    y2: 308.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 331.18,
    cy: 306.42,
    r: 4.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 330.39,
    y1: 296.1,
    x2: 327.58,
    y2: 296.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 332.13,
    y1: 295.68,
    x2: 323.95,
    y2: 295.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: -2881.64,
    cy: -3034.96,
    r: 3.86,
    gradientTransform: "matrix(0.51, 0.01, -0.03, 1.31, 1706.5, 4293.79)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 36.16,
    cy: 129.2,
    r: 2.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 341.82,
    y1: 272.41,
    x2: 331.06,
    y2: 274.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: -1927.83,
    cy: -2409.61,
    r: 8.15,
    gradientTransform: "translate(1482.53 3847.58) scale(0.59 1.48)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 339.2,
    y1: 262.56,
    x2: 327.82,
    y2: 263.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 340.64,
    cy: 248.08,
    r: 21.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 337.08,
    cy: 254.79,
    r: 8.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 28.94,
    cy: 133.06,
    r: 2.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 334.81,
    y1: 276.17,
    x2: 323.67,
    y2: 277.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: -571.76,
    cy: -1090.01,
    r: 8.01,
    gradientTransform: "translate(709.44 1583.32) scale(0.66 1.2)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 335.11,
    cy: 236.7,
    r: 9.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 339.07,
    cy: 234.92,
    r: 11.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 337.28,
    cy: 237.11,
    r: 4.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 332.48,
    y1: 252.69,
    x2: 331.96,
    y2: 262.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 341.07,
    y1: 256.75,
    x2: 325.06,
    y2: 255.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 204.51,
    y1: 589.49,
    x2: 196.34,
    y2: 592.56,
    gradientTransform: "translate(160.55 -320.79) rotate(3.61)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: 202.56,
    cy: 591.47,
    r: 4.48,
    gradientTransform: "translate(160.55 -320.79) rotate(3.61)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 382.43,
    cy: 97.74,
    r: 1.65,
    gradientTransform: "translate(-66.21 210.72) rotate(-4.73)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 384.53,
    y1: -9.62,
    x2: 377.77,
    y2: -10.17,
    gradientTransform: "matrix(1, -0.08, 0.08, 0.93, -57.73, 310.14)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: -575.05,
    cy: -2936.14,
    r: 3.57,
    gradientTransform: "matrix(0.77, -0.06, 0.12, 1.44, 1113.62, 4460.42)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 660.14,
    y1: -374.31,
    x2: 656.21,
    y2: -376.01,
    gradientTransform: "translate(-245.4 753.75) rotate(-11.6)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 64.93,
    cy: 1125.93,
    r: 1.72,
    gradientTransform: "translate(509.11 -850) rotate(12.83)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 272.31,
    y1: 326.36,
    x2: 266.06,
    y2: 324.88,
    gradientTransform: "translate(54 -69.12) rotate(0.06)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: -947.26,
    cy: 567.01,
    r: 3.71,
    gradientTransform: "matrix(0.75, 0.05, -0.08, 1.04, 1082.31, -289.05)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 335.41,
    y1: 237.66,
    x2: 329.6,
    y2: 238.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-2",
    x1: 10068.21,
    y1: 330.27,
    x2: 10081.9,
    y2: 326.17,
    gradientTransform: "matrix(-1, 0, 0, 1, 10070.36, -155.96)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-3",
    x1: 10058.47,
    y1: 331.92,
    x2: 10076.37,
    y2: 327.91,
    gradientTransform: "matrix(-1, 0, 0, 1, 10070.36, -155.96)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-4",
    x1: 10070.53,
    y1: 316.02,
    x2: 10068.07,
    y2: 320.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 10070.36, -155.96)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 9972.04,
    y1: 274.81,
    x2: 9954.43,
    y2: 251.49,
    gradientTransform: "matrix(-1, 0, 0, 1, 10070.36, -155.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2d085d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#430f87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-5",
    x1: 9965.34,
    y1: 275.84,
    x2: 10060.03,
    y2: 247.49,
    gradientTransform: "matrix(-1, 0, 0, 1, 10070.36, -155.96)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-6",
    x1: 9972.99,
    y1: 269.05,
    x2: 10001.48,
    y2: 262.66,
    gradientTransform: "matrix(-1, 0, 0, 1, 10070.36, -155.96)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 9988.96,
    y1: 293.67,
    x2: 9973.91,
    y2: 268.64,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#370b6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 9974.55,
    y1: 284.1,
    x2: 9966.9,
    y2: 270.86,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-7",
    x1: 9956.34,
    y1: 289.52,
    x2: 9962.76,
    y2: 278.46,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 9984.95,
    y1: 290.68,
    x2: 9977.31,
    y2: 277.43,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-8",
    x1: 9966.75,
    y1: 296.1,
    x2: 9973.17,
    y2: 285.03,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 9995.36,
    y1: 297.25,
    x2: 9987.72,
    y2: 284,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-9",
    x1: 9977.16,
    y1: 302.67,
    x2: 9983.58,
    y2: 291.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 10005.77,
    y1: 303.82,
    x2: 9998.13,
    y2: 290.58,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-10",
    x1: 9987.56,
    y1: 309.25,
    x2: 9993.99,
    y2: 298.18,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 10016.18,
    y1: 310.4,
    x2: 10008.53,
    y2: 297.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-11",
    x1: 9997.97,
    y1: 315.82,
    x2: 10004.39,
    y2: 304.75,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 10026.59,
    y1: 316.97,
    x2: 10018.94,
    y2: 303.73,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-12",
    x1: 10008.38,
    y1: 322.39,
    x2: 10014.8,
    y2: 311.33,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 10037,
    y1: 323.55,
    x2: 10029.35,
    y2: 310.3,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-13",
    x1: 10018.79,
    y1: 328.97,
    x2: 10025.21,
    y2: 317.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 10047.4,
    y1: 330.12,
    x2: 10039.76,
    y2: 316.87,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-14",
    x1: 10029.2,
    y1: 335.54,
    x2: 10035.62,
    y2: 324.47,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 10057.81,
    y1: 336.69,
    x2: 10050.17,
    y2: 323.45,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-15",
    x1: 10039.61,
    y1: 342.12,
    x2: 10046.03,
    y2: 331.05,
    gradientTransform: "matrix(-1, 0, 0, 1, 10372.64, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 10019.45,
    y1: 312.75,
    x2: 10041,
    y2: 348.45,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-16",
    x1: 9938.12,
    y1: 287.91,
    x2: 9969.08,
    y2: 280.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 10070.36, -155.96)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-17",
    x1: 10003.83,
    y1: 193.47,
    x2: 9963.15,
    y2: 270.99,
    gradientTransform: "matrix(-1, 0, 0, 1, 10070.36, -155.96)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-18",
    x1: 10041.05,
    y1: 347.47,
    x2: 10054.74,
    y2: 343.37,
    gradientTransform: "matrix(-1, 0, 0, 1, 10070.36, -155.96)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-19",
    x1: 10031.31,
    y1: 349.12,
    x2: 10049.21,
    y2: 345.11,
    gradientTransform: "matrix(-1, 0, 0, 1, 10070.36, -155.96)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-20",
    x1: 10043.37,
    y1: 333.22,
    x2: 10040.91,
    y2: 337.91,
    gradientTransform: "matrix(-1, 0, 0, 1, 10070.36, -155.96)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 383.78,
    y1: 359.25,
    x2: 365.31,
    y2: 356.58,
    gradientTransform: "matrix(1.26, -0.78, 0.53, 0.85, -294.42, 288.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#553ad0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#553ad0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 380.99,
    y1: 356.46,
    x2: 373.56,
    y2: 350.08,
    gradientTransform: "matrix(1.26, -0.78, 0.53, 0.85, -294.42, 288.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a0389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#553bd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 369.14,
    y1: 348.06,
    x2: 367.75,
    y2: 358.62,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 411.06,
    y1: 346.19,
    x2: 408.15,
    y2: 351.88,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 387.36,
    y1: 360.57,
    x2: 405.35,
    y2: 346.98,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 379.34,
    y1: 341.08,
    x2: 378.44,
    y2: 359.39,
    gradientTransform: "matrix(1.26, -0.78, 0.53, 0.85, -294.42, 288.65)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 347.93,
    y1: 344.61,
    x2: 364.18,
    y2: 344.61,
    gradientTransform: "matrix(1.26, -0.78, 0.53, 0.85, -294.42, 288.65)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 379.29,
    y1: 359.65,
    x2: 380.62,
    y2: 343.04,
    gradientTransform: "matrix(1.26, -0.78, 0.53, 0.85, -294.42, 288.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 398.42,
    y1: 353.8,
    x2: 402.72,
    y2: 347.41,
    gradientTransform: "matrix(1.26, -0.78, 0.53, 0.85, -294.42, 288.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff17d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ff88ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 351.69,
    y1: 359.35,
    x2: 358.91,
    y2: 343.9,
    gradientTransform: "matrix(1.26, -0.78, 0.53, 0.85, -294.42, 288.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff17d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd394"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "305.72 23.87 208.07 38.42 233.56 48.99 156.37 94.79 191.72 109.46 268.92 63.66 293.53 73.88 305.72 23.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "304.93 12.35 207.28 26.89 232.77 37.47 155.57 83.27 190.93 97.94 268.12 52.14 292.73 62.35 304.93 12.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "291.88 50.01 292.73 62.35 304.93 12.35 304.07 0 291.88 50.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "206.42 14.55 207.28 26.89 232.77 37.47 231.91 25.13 206.42 14.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "268.12 52.14 267.27 39.8 291.88 50.01 292.73 62.35 268.12 52.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "304.07 0 206.42 14.55 231.91 25.13 154.72 70.92 190.07 85.59 267.27 39.8 291.88 50.01 304.07 0"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "230.16 25.12 231.38 24.39 208.66 14.96 206.47 15.29 230.16 25.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "303.15 0.89 291.35 49.27 266.74 39.06 189.54 84.86 155.99 70.94 154.77 71.67 190.12 86.34 267.32 40.54 291.93 50.75 304.12 0.74 303.15 0.89"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M560.78,193.33a6.23,6.23,0,0,1-1.75,2.93,27.84,27.84,0,0,1-8.77,7c-4.82,2.25-9.86,1.42-14.79,1.43a19,19,0,0,0-8.51,1.76c-5.63,2.88-10.09,12.83-16.62,14.55-5.38,1.42-9.31-.51-13.35-1.61a77.73,77.73,0,0,0-9.11-2.27c-4.09-.6-8.21-.23-12.17,2.88l-.13.09c-2.1,1.68-4.66,4.13-7.78,3.42a4.92,4.92,0,0,1-3.25-2.94l-.26-.51-.24-.52a22.74,22.74,0,0,1-2-9.53,1.74,1.74,0,0,1,1.08-1.82,2.09,2.09,0,0,1,2.12.94c2.33,2.65,5.7,4.34,9.53,5.43a59.08,59.08,0,0,0,12.57,1.83h.08c3.18.18,6.24.53,9.42.7,6.36.34,12.64-.62,17.65-4.69,4.6-3.74,7-9.14,14-10.65,6.49-1.41,11.42,3.29,17.65,1.47a9.77,9.77,0,0,0,5-3.48c1.47-1.92,2-4,3.22-6a8.3,8.3,0,0,1,.71-1,5.46,5.46,0,0,1,1.17-1.07,4.16,4.16,0,0,1,2.94-.72A2,2,0,0,1,560.78,193.33Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M469.18,217.26c-2.59,1.22-4.47,2.7-7.33,3.35-2.39.54-4.59.47-5.81-.15-1.87-.94-1.76-2.9-.59-4.93a5.55,5.55,0,0,1,3.14-2.48,4.53,4.53,0,0,1,2.52-.06,7.16,7.16,0,0,0,5.26-.22,28.14,28.14,0,0,0,4.29-2.14,31.55,31.55,0,0,1,4.26-2.18c6.1-2.39,9.56-.4,12.67.55a18.72,18.72,0,0,0,12-.1,30.37,30.37,0,0,0,10.52-7.12c2.53-2.59,5.12-5.34,8.14-7.93,7.32-6.29,13.32-3.67,20.91-5.17,4.45-.88,7.23-2.73,9.1-5.23,1.54-2.06,2.34-4.13,4.89-6.18,1.76-1.4,5.13-2.86,6.61-2.34,1.24.44.2,1.9-.86,3.11a61.58,61.58,0,0,1-6.62,6.78,38.85,38.85,0,0,1-9.93,6.09c-7.6,3.17-16.21,3.74-23.08,7.62-3.34,1.89-5.46,4.15-7.81,6.29a25.75,25.75,0,0,1-9.24,5.7c-3.73,1.21-6.92,1-10.16,1.09A61.06,61.06,0,0,0,469.18,217.26Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "131.81 87.52 131.81 154.2 194.11 117.86 194.11 51.19 131.81 87.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "131.85 87.52 131.85 154.2 69.34 117.76 69.34 51.12 131.85 87.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "131.85 87.52 131.85 154.2 69.34 117.76 69.34 51.12 131.85 87.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "69.34 51.12 131.85 87.52 194.11 51.19 131.54 14.75 69.34 51.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "126.8 90.48 75.07 60.3 75.07 73.91 126.8 104.08 126.8 90.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M429.58,260.91l-52.73-30.76V215.4l52.73,30.75Zm-51.73-31.33,50.73,29.59V246.73l-50.73-29.59Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "120.22 92.47 122.23 93.63 122.23 91.32 120.22 90.16 120.22 92.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "116.44 90.29 118.45 91.45 118.45 89.14 116.44 87.98 116.44 90.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "112.66 88.11 114.67 89.27 114.67 86.96 112.66 85.8 112.66 88.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "108.89 85.92 110.9 87.09 110.9 84.78 108.89 83.62 108.89 85.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "105.11 83.74 107.12 84.91 107.12 82.6 105.11 81.44 105.11 83.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "101.33 81.56 103.34 82.72 103.34 80.42 101.33 79.26 101.33 81.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "97.56 79.38 99.57 80.54 99.57 78.24 97.56 77.08 97.56 79.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "93.78 77.2 95.79 78.36 95.79 76.06 93.78 74.9 93.78 77.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "90 75.02 92.01 76.18 92.01 73.88 90 72.72 90 75.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "86.23 72.84 88.24 74 88.24 71.7 86.23 70.53 86.23 72.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "82.45 70.66 84.46 71.82 84.46 69.52 82.45 68.35 82.45 70.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "78.67 68.48 80.68 69.64 80.68 67.33 78.67 66.17 78.67 68.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "120.22 96.57 122.23 97.73 122.23 95.42 120.22 94.26 120.22 96.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "116.44 94.39 118.45 95.55 118.45 93.24 116.44 92.08 116.44 94.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "112.66 92.21 114.67 93.37 114.67 91.06 112.66 89.9 112.66 92.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "108.89 90.03 110.9 91.19 110.9 88.88 108.89 87.72 108.89 90.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "105.11 87.84 107.12 89 107.12 86.7 105.11 85.54 105.11 87.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "101.33 85.66 103.34 86.83 103.34 84.52 101.33 83.36 101.33 85.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "97.56 83.48 99.57 84.64 99.57 82.34 97.56 81.18 97.56 83.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "93.78 81.3 95.79 82.46 95.79 80.16 93.78 79 93.78 81.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "90 79.12 92.01 80.28 92.01 77.98 90 76.82 90 79.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "86.23 76.94 88.24 78.1 88.24 75.8 86.23 74.64 86.23 76.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "82.45 74.76 84.46 75.92 84.46 73.61 82.45 72.45 82.45 74.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "78.67 72.58 80.68 73.74 80.68 71.44 78.67 70.27 78.67 72.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "80.94 50.23 131.37 79.6 182.48 50.19 132 20.79 80.94 50.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "189.58 102.46 136.36 133.19 136.36 90.4 189.58 59.68 189.58 102.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "150.76 85.75 139.5 92.25 139.5 93.83 150.76 87.31 150.76 85.75"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M439,288.77V246.6l53.15-30.68v42.16Zm.75-41.73v40.43l51.65-29.83V217.22Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 184.13,
    y: 63.64,
    width: 0.75,
    height: 41.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 178.14,
    y: 67.07,
    width: 0.75,
    height: 41.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 172.16,
    y: 70.51,
    width: 0.75,
    height: 41.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 166.17,
    y: 73.94,
    width: 0.75,
    height: 41.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 160.19,
    y: 77.38,
    width: 0.75,
    height: 41.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 154.2,
    y: 80.81,
    width: 0.75,
    height: 41.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 148.22,
    y: 84.25,
    width: 0.75,
    height: 41.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 142.23,
    y: 87.68,
    width: 0.75,
    height: 41.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 435.29,
    y: 237.03,
    width: 60.51,
    height: 0.75,
    transform: "translate(-358.63 108.31) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 435.29,
    y: 243.07,
    width: 60.51,
    height: 0.75,
    transform: "translate(-361.65 109.12) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 435.29,
    y: 249.12,
    width: 60.51,
    height: 0.75,
    transform: "translate(-364.67 109.93) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 435.29,
    y: 255.17,
    width: 60.51,
    height: 0.75,
    transform: "translate(-367.69 110.74) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 435.29,
    y: 261.22,
    width: 60.51,
    height: 0.75,
    transform: "translate(-370.71 111.54) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 435.29,
    y: 267.26,
    width: 60.51,
    height: 0.75,
    transform: "translate(-373.73 112.35) rotate(-29.97)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "147.65 92.55 139.5 97.3 139.5 98.31 147.65 93.56 147.65 92.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "147.65 90.72 139.5 95.47 139.5 96.48 147.65 91.73 147.65 90.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "147.65 96.17 139.5 100.92 139.5 101.92 147.65 97.17 147.65 96.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "147.65 94.34 139.5 99.09 139.5 100.09 147.65 95.34 147.65 94.34"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M455.11,242a.33.33,0,0,1-.31-.18.35.35,0,0,1,.13-.47l1.34-.75a.35.35,0,0,1,.48.13.36.36,0,0,1-.14.48l-1.33.75A.38.38,0,0,1,455.11,242Zm3.08-1.72a.38.38,0,0,1-.31-.18.36.36,0,0,1,.14-.48l1.74-1a.35.35,0,1,1,.34.62l-1.74,1A.37.37,0,0,1,458.19,240.25Zm3.49-2a.36.36,0,0,1-.31-.18.35.35,0,0,1,.14-.47l1.74-1a.35.35,0,1,1,.34.61l-1.74,1A.35.35,0,0,1,461.68,238.29Zm3.49-1.95a.37.37,0,0,1-.31-.18.36.36,0,0,1,.14-.48l1.74-1a.35.35,0,0,1,.48.13.36.36,0,0,1-.14.48l-1.74,1A.37.37,0,0,1,465.17,236.34Zm3.49-2a.36.36,0,0,1-.31-.18.35.35,0,0,1,.14-.47l1.74-1a.37.37,0,0,1,.48.13.36.36,0,0,1-.14.48l-1.74,1A.35.35,0,0,1,468.66,234.38Zm3.49-1.95a.38.38,0,0,1-.31-.18.36.36,0,0,1,.14-.48l1.74-1a.35.35,0,0,1,.48.13.36.36,0,0,1-.14.48l-1.74,1A.37.37,0,0,1,472.15,232.43Zm3.49-2a.35.35,0,0,1-.17-.65l1.74-1a.36.36,0,0,1,.48.14.35.35,0,0,1-.14.47l-1.74,1A.35.35,0,0,1,475.64,230.47Zm3.49-1.95a.37.37,0,0,1-.31-.18.36.36,0,0,1,.14-.48l1.74-1a.35.35,0,0,1,.48.13.36.36,0,0,1-.14.48l-1.74,1A.37.37,0,0,1,479.13,228.52Zm3.49-2a.37.37,0,0,1-.31-.17.36.36,0,0,1,.14-.48l1.74-1a.36.36,0,0,1,.48.14.35.35,0,0,1-.14.47l-1.74,1A.35.35,0,0,1,482.62,226.56Zm3.49-1.95a.35.35,0,0,1-.17-.65l1.74-1a.35.35,0,0,1,.48.13.36.36,0,0,1-.14.48l-1.74,1A.35.35,0,0,1,486.11,224.61Zm3.49-2a.37.37,0,0,1-.31-.18.36.36,0,0,1,.14-.48l1.74-1a.36.36,0,0,1,.48.14.35.35,0,0,1-.14.47l-1.74,1A.37.37,0,0,1,489.6,222.66Z",
    transform: "translate(-302.28 -155.96)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "189.32 65.25 189.32 101.58 136.85 131.87 136.85 120.78 142.5 109.08 149.09 108.39 159.21 92.78 167.88 95.02 172.88 81.68 181.8 80.16 189.32 65.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "189.32 76.83 189.32 101.58 136.85 131.87 136.85 123.44 145.79 112.73 150.5 115.12 158.97 98.69 169.27 101.08 175.3 90.39 182.94 86.57 189.32 76.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "189.32 86.45 189.32 101.58 136.85 131.87 136.85 127.66 140.62 121.27 147.21 122.79 156.62 110.7 166.03 109.26 172.46 101.24 182.45 93.97 189.32 86.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M376.6,252a1.32,1.32,0,0,1-.54,1.21l-.62.36c-.34.2-.12-.24-.65-.55a4.21,4.21,0,0,1-1.91-3.3c0-.6-.56-.61-.22-.81l.69-.37a1.35,1.35,0,0,1,1.33.15A4.22,4.22,0,0,1,376.6,252Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 374.02,
    cy: 251.27,
    rx: 1.56,
    ry: 2.7,
    transform: "translate(-377.97 67.15) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M375.47,252.3a1.14,1.14,0,0,1-.47,1l-.92.55c-.3.17-.11-.21-.56-.47a3.61,3.61,0,0,1-1.65-2.84c0-.51-.47-.52-.18-.69l1-.56a1.17,1.17,0,0,1,1.15.13A3.61,3.61,0,0,1,375.47,252.3Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M374.5,252.86c0,1-.74,1.47-1.65.94a3.6,3.6,0,0,1-1.64-2.84c0-1,.73-1.46,1.64-.94A3.64,3.64,0,0,1,374.5,252.86Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M374.11,249a1.39,1.39,0,0,0-1.31-.16,1.48,1.48,0,0,1,1.14.22,4.22,4.22,0,0,1,1.92,3.31,1.28,1.28,0,0,1-.61,1.25c.47-.13.77-.59.77-1.31A4.21,4.21,0,0,0,374.11,249Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M372.92,250a1.19,1.19,0,0,0-1.13-.14,1.27,1.27,0,0,1,1,.2,3.61,3.61,0,0,1,1.66,2.85,1.11,1.11,0,0,1-.53,1.08c.41-.11.67-.51.67-1.14A3.63,3.63,0,0,0,372.92,250Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M470.54,324.22c6.13,2.56,9.16.52,13.76-2.14s5.13-5.28,1.59-6.94c-6.68-3.13-10.49,0-15.09,2.69S466.93,322.71,470.54,324.22Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M488.54,283.42c.47.21.67.41.53.89s-.43,2.26-.52,3a9.31,9.31,0,0,1-1.09,2.36,2.54,2.54,0,0,1-.53,1c-.34.31-.52.15-.59.05s0-.41.11-.58a8.55,8.55,0,0,0,.3-1.08s-.55,1.16-.74,1.6-.59.83-.89.79a.35.35,0,0,1-.31-.44,5.68,5.68,0,0,0,.47-.91c.07-.31.17-.81.17-.81a7.14,7.14,0,0,1-.7,1.6c-.19.26-.68,1.28-1.15.92s.31-1.14.43-1.4a9.94,9.94,0,0,0,.75-3.14c0-.68-.17-1-.89-.54s-1.37.71-1.45.36.64-1,1.1-1.33a7.79,7.79,0,0,1,1.71-1c1-.39,1.22-1.43,1.88-1.63A2,2,0,0,1,488.54,283.42Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M488.54,283.42c.47.21.67.41.53.89s-.43,2.26-.52,3a9.31,9.31,0,0,1-1.09,2.36,2.54,2.54,0,0,1-.53,1c-.34.31-.52.15-.59.05s0-.41.11-.58a8.55,8.55,0,0,0,.3-1.08s-.55,1.16-.74,1.6-.59.83-.89.79a.35.35,0,0,1-.31-.44,5.68,5.68,0,0,0,.47-.91c.07-.31.17-.81.17-.81a7.14,7.14,0,0,1-.7,1.6c-.19.26-.68,1.28-1.15.92s.31-1.14.43-1.4a9.94,9.94,0,0,0,.75-3.14c0-.68-.17-1-.89-.54s-1.37.71-1.45.36.64-1,1.1-1.33a7.79,7.79,0,0,1,1.71-1c1-.39,1.22-1.43,1.88-1.63A2,2,0,0,1,488.54,283.42Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M489.74,261.83a1.47,1.47,0,1,1-1.46-1.46A1.47,1.47,0,0,1,489.74,261.83Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M489.52,283.36a1.22,1.22,0,1,1-1-1.42A1.22,1.22,0,0,1,489.52,283.36Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M491.78,271.5c.48.34.49,1.37-.21,4.42s-1.52,7.1-1.94,7.41-2.23-.34-2.42-.83.3-2.66.65-4.93c.4-2.59.35-4.21.88-4.92S491,271,491.78,271.5Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M490.61,271.67c.26.27.19,1.23-.41,4.1a69.22,69.22,0,0,1-1.62,7c-.27.32-1.27-.17-1.35-.6a37.73,37.73,0,0,1,.71-4.62c.4-2.41.48-3.91.83-4.61S490.18,271.22,490.61,271.67Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M492,271.18a1.46,1.46,0,1,1-1.32-1.59A1.47,1.47,0,0,1,492,271.18Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M490.34,261.36c.53,0,.74,1.24.86,2.72s.53,5.46.52,5.84-2,1.42-2.63,1.45-1-3.39-1.2-4.62c-.22-1.49-.29-2.64,0-3.11S489.76,261.41,490.34,261.36Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M488.8,262.17c.22-.07.43,1.11.62,2.49s.72,5,.75,5.4a2.29,2.29,0,0,1-1,1.48c-.25,0-.74-3.11-.93-4.24a11.65,11.65,0,0,1-.28-2.9A6.75,6.75,0,0,1,488.8,262.17Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M479,320.22c.67.6,1,2.75.11,3.53s-1.74.05-3.64,0-5.53-.83-5.64-2.12,1.49-1.41,2.75-1.52,2.45-.71,3.2-.77A5.3,5.3,0,0,1,479,320.22Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M479,320.22c.67.6,1,2.75.11,3.53s-1.74.05-3.64,0-5.53-.83-5.64-2.12,1.49-1.41,2.75-1.52,2.45-.71,3.2-.77A5.3,5.3,0,0,1,479,320.22Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M479.21,319.74a1.47,1.47,0,1,1-1.47-1.47A1.47,1.47,0,0,1,479.21,319.74Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M485,316.65c.55.53,1.15,3.69.05,4.19a2.34,2.34,0,0,1-2.67-.91,4.84,4.84,0,0,0-1.73-1.51c-.72-.39-1.66-1.93-.89-2.62s2.15.14,2.68.14A3.85,3.85,0,0,1,485,316.65Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M485,316.65a2.09,2.09,0,0,1-.72,2.86c-1.1.5-2.92-.71-3.63-1.09s-1.66-1.93-.89-2.62,2.15.14,2.68.14A3.85,3.85,0,0,1,485,316.65Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 181.24,
    cy: 160.11,
    r: 1.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M483.77,299.25c1.57,1.57,1.82,15.94,1.07,16.52s-2.51.48-2.76-.31-.49-3.59-1.11-7.83c-.66-4.48-1.36-6.16-1-7.44A2.36,2.36,0,0,1,483.77,299.25Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M483.22,300.06c1.28,1.24,1.54,14,1,14.47s-1.91.4-2.1-.27-.27-3.28-.66-6.91c-.43-4.09-.95-6-.87-6.48C480.76,299.62,481.75,298.64,483.22,300.06Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M483.34,298.89a1.87,1.87,0,1,1-1.87-1.87A1.87,1.87,0,0,1,483.34,298.89Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M483.48,298.06c-.35,2.1-3.87,1.89-4.36.45s-.14-12.59-.16-15.74c0-2.9.11-7.75,3.36-7.42s4.51,2.78,4.26,5.37-2.2,8.4-2.61,11.65S483.61,297.26,483.48,298.06Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M453.66,255.27a2.47,2.47,0,0,0,0-1.24c-.08-.62.37-1.28.37-2.27a20.14,20.14,0,0,0-.27-2.29c0-.52-.18-.77-.59-.5s-.23,1.88-.5,2.11-1.3-.89-2.07-2.13-1.05-2.31-1.44-2.31-.46.47-.17,1.13l.77,1.74a10,10,0,0,1-.85-1.37c-.18-.39-.15-.59-.37-.66s-.45.62-.21,1.39a8.39,8.39,0,0,0,.62,1.4,4.21,4.21,0,0,1-.51-.78c-.15-.33-.13-.37-.31-.37s-.26.8,0,1.23.4.71.4.71-.31-.64-.48-.6.25,1.11.38,1.4a10.79,10.79,0,0,0,1.63,2.29c.72.75,1.3,2.17,1.73,2.34S453.52,255.85,453.66,255.27Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M453.66,255.27a2.47,2.47,0,0,0,0-1.24c-.08-.62.37-1.28.37-2.27a20.14,20.14,0,0,0-.27-2.29c0-.52-.18-.77-.59-.5s-.23,1.88-.5,2.11-1.3-.89-2.07-2.13-1.05-2.31-1.44-2.31-.46.47-.17,1.13l.77,1.74a10,10,0,0,1-.85-1.37c-.18-.39-.15-.59-.37-.66s-.45.62-.21,1.39a8.39,8.39,0,0,0,.62,1.4,4.21,4.21,0,0,1-.51-.78c-.15-.33-.13-.37-.31-.37s-.26.8,0,1.23.4.71.4.71-.31-.64-.48-.6.25,1.11.38,1.4a10.79,10.79,0,0,0,1.63,2.29c.72.75,1.3,2.17,1.73,2.34S453.52,255.85,453.66,255.27Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-59",
    cx: 150.82,
    cy: 100.37,
    r: 1.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M454.06,255.59c-.46-.11-1.6.88-1.69,1.53-.16,1.08,8.26,11.56,10.68,11.7,1.84.12,2.9-1.88,1.24-3.51C463.33,264.36,455.14,255.86,454.06,255.59Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M455.51,257.12c-.31-.09-1.07.8-1.16,1.2-.15.65,5.34,7.45,7,7.65a1.35,1.35,0,0,0,.92-2.44C461.66,262.91,456.26,257.33,455.51,257.12Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M485.79,268.93c-.22,1.24-1.94,10.51-3.67,12.73-1,1.33-4.67,1.43-5.88.62-1.57-1.07-1.66-8.78-1.66-8.78Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M483.84,257.34c1.74-.13,5.42,0,5.66,2s-1.32,3.7-1.69,4.69-.61,4.27-1,5.43-.91,3-4.38,4.09-7.2,1.16-8,.29-3-7-2.56-9.7,3.76-4.92,6.28-5.7A20.62,20.62,0,0,1,483.84,257.34Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M483.84,257.34c1.74-.13,5.42,0,5.66,2s-1.32,3.7-1.69,4.69-.61,4.27-1,5.43-.91,3-4.38,4.09-7.2,1.16-8,.29-3-7-2.56-9.7,3.76-4.92,6.28-5.7A20.62,20.62,0,0,1,483.84,257.34Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M483.84,257.34c1.74-.13,5.42,0,5.66,2s-2.81,3.78-3.8,4.14c-5.26,1.89-14.29,3.34-13.83.66s3.76-4.92,6.28-5.7A20.62,20.62,0,0,1,483.84,257.34Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M471.81,265c.15-.66.46,1.67,2.19,2.17s3,.52,3.18,1.7c.12.83.33,3.69-.63,5.37a2.77,2.77,0,0,1-2.12-.41C473.68,273.08,471.83,268,471.81,265Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M474.76,267.46a4.44,4.44,0,0,1-2.4-1.57c0-.12-.16.25-1,.58s-1.57,2.15-.58,2.73,2.6,1.36,3.72.78S476,267.54,474.76,267.46Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M479,319.55c-.6.46-2.57.08-2.74-.41s-1-4.69-1.84-8.06c-.95-3.9-1.77-6.13-1.65-7.06s2.08-1.66,3.07-1.46,1.33.82,1.58,2.16,1.12,6.33,1.35,9.08C479,316.27,479.48,319.16,479,319.55Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M478.55,319.35c-.41.5-1.9.24-2.06-.25s-1.12-4.61-2-7.93c-1-3.84-1.78-6-1.76-6.95a2,2,0,0,1,2.17-1.63c.75.13,1.06.75,1.34,2.06s1.31,6.26,1.69,9C478.29,316.09,478.89,318.94,478.55,319.35Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M476,302.59a1.86,1.86,0,1,1-1.86-1.86A1.87,1.87,0,0,1,476,302.59Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M466.09,267.43a1.47,1.47,0,1,1-1.46-1.47A1.46,1.46,0,0,1,466.09,267.43Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M465.15,265.9c-.84.08-1,1.38-.82,2.2s.51,1.23,1.93,1.6c1.23.32,6.49,1.3,7.48,1.11s.29-2.38-.66-3.37-1.08-1.14-2.35-1.14S466.46,265.77,465.15,265.9Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M465.15,266.05c-.84.07-1,1.2-.82,1.91s.51,1.08,1.93,1.4a46.74,46.74,0,0,0,7.48,1c1-.16.11-2.19-.86-2.93s-.88-1-2.15-1S466.46,265.94,465.15,266.05Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M481.75,247.67a3.72,3.72,0,0,1,1.16,4.54c-.7,1.74-1.61,2.15-1.16,3.8s.93,1.71.75,2.2-.7.74-1.94,1a4,4,0,0,1-2.64-.17c-.28-.3,0-1.47-.46-2.27l-.59-1.08S478.24,245.44,481.75,247.67Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M478,256a3.51,3.51,0,0,1-2.48.08c-.5-.31-1.73-5.17-.82-7.27s5-3.52,7.4-1.47c1.92,1.64,1.36,3.51,1.14,3.54-.53.08-3.45.86-3.82,1.6S478.9,255.32,478,256Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M476.2,302a2.83,2.83,0,0,1-3.22,1.24c-1.05-.21-1.51-1.15-1.51-2.31s0-10.6.3-13.8c.17-2.29.2-7.28,2.67-8.3a4.47,4.47,0,0,1,6.33,4.8c-.62,2.59-2.88,6-3.46,9.78S476.77,301.05,476.2,302Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M474.22,301.08c-.41,1.1-1.12,1.35-1.82,1.11s-.83-1.07-.81-2.13.27-9.48.45-12.41c.13-2.1,0-7.38,1.49-7.82,2.4-.68,3.63,2,3.47,4.46-.12,2-1.68,5.45-2.05,8.93S474.55,300.21,474.22,301.08Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M476.78,256c.68-.43,1.6-2.16,2-4.75.3-1.77,2.84-2.21,4.42-2.32.41,1.07.11,1.93,0,2-.53.08-3.45.86-3.82,1.6s-.47,2.86-1.42,3.52a3.53,3.53,0,0,1-1.66.26A4.48,4.48,0,0,0,476.78,256Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M362.51,252.64c.06.29.12.86,1.27.8s2,.19,2.36.13a5.59,5.59,0,0,1,1.56-.07c.52.08.93.43,1.22.28s.09-.59-.19-.72a7,7,0,0,0-.8-.25,5.13,5.13,0,0,1,1.55.17c.32.2.68.58,1,.36s-.26-.79-.63-.94a3.8,3.8,0,0,0-.83-.21,5.44,5.44,0,0,1,1.49.19c.34.17,1,.61,1.17.41s0-.59-.5-.85a2.19,2.19,0,0,0-.47-.19,5.38,5.38,0,0,0,1.27.08c.16-.09.27-.55-.27-.66a24.68,24.68,0,0,0-3.08-.39c-.6,0-1.67,0-3.07,0a8.7,8.7,0,0,0-2.37.24A1.62,1.62,0,0,0,362.51,252.64Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M365.59,251.08c-.76,0-2.11-.22-2.42-.08a1.62,1.62,0,0,0-.66,1.64c.06.29.12.86,1.27.8a21.2,21.2,0,0,1,2.24.13c.13-.26.15-.68.51-.83a17.33,17.33,0,0,1,2.17-.52c.4-.08.51-.59.24-.72a7.67,7.67,0,0,0-1.66-.07,12.41,12.41,0,0,1-1.61-.36Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M362.27,251.07a1.13,1.13,0,1,1-.83,1.37A1.12,1.12,0,0,1,362.27,251.07Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M348.12,251c-.31,1-.11,1.87,2,2.3a68.63,68.63,0,0,0,11.38.18A1.63,1.63,0,0,0,363,252c0-.52-.25-1-1.21-1.16s-9.64-1.05-10.63-1.24C349.48,249.31,348.42,250,348.12,251Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M349,250.63c-.11.61.21,1.12,2.17,1.43a95.08,95.08,0,0,0,10.39.43c.95-.07,1.25-.49,1.19-.8s-.4-.63-1.3-.73-9-.9-9.89-1C349.91,249.68,349.06,250.06,349,250.63Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M350.23,251.43a1.47,1.47,0,1,1-1.1-1.75A1.46,1.46,0,0,1,350.23,251.43Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M343.06,247.87c-.36,1-2.82.27-3.83-.09a1.93,1.93,0,0,1,1.31-3.64C341.54,244.5,343.42,246.87,343.06,247.87Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M340.3,243.75c-.76.17-1.2,3.47-1,4s3.89,2.32,5.85,3.24c2.2,1,2.8,1.39,3.51.75a1.64,1.64,0,0,0,.6-1.94C348.58,248.71,341.22,243.54,340.3,243.75Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M340.93,244.23c-.73.05-1.41,2.35-1.23,2.78s3.47,2.07,5.24,2.93c2,1,2.53,1.28,3.25.9s.92-1,.72-1.32C348.33,248.64,341.81,244.18,340.93,244.23Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M326.56,310.23c6.31,2.63,9.42.54,14.16-2.2s5.28-5.44,1.63-7.14c-6.87-3.22-10.79,0-15.52,2.76S322.85,308.68,326.56,310.23Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M334.48,299.42a2.2,2.2,0,0,0-1.46,1.8c-.16,1-.06,2.28,1.52,2.38a5.82,5.82,0,0,1,3.43,1c.91.69,3.79,1.12,4.47.33s-.3-1.32-1.13-1.82a12.27,12.27,0,0,1-3.07-2.45,2.94,2.94,0,0,0-1.78-1.23A3.63,3.63,0,0,0,334.48,299.42Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M335.69,300.06a1.65,1.65,0,0,0-1.08,1.34c-.12.75,0,1.7,1.13,1.77a4.32,4.32,0,0,1,2.55.77c.68.51,2.81.82,3.32.24s-.22-1-.84-1.36a9,9,0,0,1-2.28-1.81,2.19,2.19,0,0,0-1.32-.92A2.7,2.7,0,0,0,335.69,300.06Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M336.13,284.66a21.83,21.83,0,0,0-1,4.25c-.4,1.94-1.31,4.59-1.17,7.08s-.42,3.92-.06,4.3a1.42,1.42,0,0,0,1.72.14c.61-.36,1-.62.85-1s-.95-1.72-.28-4.69,1.61-6.95,2-7.32.74-.26,1.17-.89S336.86,283.45,336.13,284.66Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M333.57,298.69c.47.56,2.37.15,2.75-.25s1.27-5,2-7.61c.68-2.33,1.5-4.25,1.16-4.79s-1.84-2.52-3.31-1.81S334.35,288.6,334,291,333.1,298.13,333.57,298.69Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M334.68,298.62c.22.5,1.27.22,1.49-.12s1-4.34,1.53-6.59c.49-2,1.05-3.67.89-4.15s-.84-2.27-1.67-1.7-1.24,3.76-1.58,5.88S334.46,298.11,334.68,298.62Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M327.54,303.13a3,3,0,0,0-.69,2.89,10.5,10.5,0,0,0,2,3.42c.78.74,1.78,1.88,3.49,1.25s.15-3.13-.36-3.78a6.66,6.66,0,0,1-1.29-2.61c-.15-.87-.53-1.05-1-1.09S328,302.6,327.54,303.13Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M328,303.92a2.16,2.16,0,0,0-.6,2.28,8,8,0,0,0,1.75,2.7c.69.59,1.55,1.48,3.05,1s.12-2.48-.32-3a5.23,5.23,0,0,1-1.13-2c-.12-.69-.46-.83-.86-.86S328.43,303.51,328,303.92Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M328.57,288.72a21,21,0,0,0-.81,5.56c-.1,2.36.05,5.88.07,6.91a11.23,11.23,0,0,1-.19,1.92,1.09,1.09,0,0,0,1.4,1c.93-.28,1.45-.85,1.27-1.37a13.78,13.78,0,0,1-.46-5.78,24.66,24.66,0,0,1,1.11-5.52c.2-.31.69-.67.85-1.07S329.44,286.47,328.57,288.72Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M327.39,302a2.84,2.84,0,0,0,2.87-.13c.41-.5,1-5.18,1.34-7.3.31-1.85,1.16-3.78.31-4.34s-2-2.08-3.34-1.52c-.82.33-1.34,7-1.34,8.48C327.23,299.63,327.39,302,327.39,302Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M328.55,301.56a1,1,0,0,0,1.47-.06c.22-.4.32-4.71.65-6.13s.83-2.73.41-3.19-.95-1.69-1.67-1.26c-.43.25-.82,5.57-.84,6.78C328.52,299.66,328.55,301.56,328.55,301.56Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-98",
    cx: 35.73,
    cy: 129.08,
    r: 1.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M336.31,283.62a2.11,2.11,0,1,0,4.21,0c.05-.87-1-18.06-1.62-19.84s-2.48-3.72-4.91-2.65-2.48,4-1.4,6.53a51.61,51.61,0,0,1,2.7,9.11C335.61,278.82,336.31,282.48,336.31,283.62Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M337.73,283.08c0,.8.45,1.88,1.12,1.88s1-1.13,1.06-1.88-.5-15.78-.84-17.33-1.28-3.25-2.54-2.31-1.28,3.49-.72,5.7a72,72,0,0,1,1.39,8C337.37,278.89,337.73,282.09,337.73,283.08Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M333.94,269.65a5.43,5.43,0,0,0,3.77-4.36c.24-1.39.86-9.17.86-9.17s-9.11.43-9.65,1,.26,3.81-1,7.13C326.86,267.09,331.49,270.47,333.94,269.65Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M336.69,242.18c.91,0,3,.11,3.58,1.49s-.59,3.58-.59,3.58a8.21,8.21,0,0,1,.62,4.1,7.56,7.56,0,0,0-.38,2.1c0,.16.89,2.83.16,3a5.16,5.16,0,0,0-1.56.25c-.57.27-.86,1-1.86,1.67-1.16.78-5.62,2.78-6.82,2.72-2.78-.13-3.56-3.61-4.26-5.71-.59-1.77-1.1-4.24-1.1-4.24s-1.76-.27-1.7-1.48,1.52-2.21,2.92-3.4a31.39,31.39,0,0,1,3.66-2.69C330.16,243.07,335,242.24,336.69,242.18Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M336.38,242.56c.83,0,2.71.1,3.25,1.34s-.54,3.25-.54,3.25a8.33,8.33,0,0,1,1.08,3.32,5.85,5.85,0,0,1-.37,2.24,21,21,0,0,1-4,2c-2.72.84-5.59-.06-6.23-2-.53-1.6-4.22-2.09-4.22-2.09s-1.58-.25-1.54-1.35,1.38-2,2.65-3.08a29.57,29.57,0,0,1,3.31-2.44A28.81,28.81,0,0,1,336.38,242.56Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-104",
    cx: 28.52,
    cy: 133.06,
    r: 1.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M328.79,289.14c.63.43,3.18-.16,3.91-.24s.91-.89.89-1.19a91.47,91.47,0,0,1-.41-9.54c.11-4.26,1-7.64,0-10.19s-3.38-4.47-5.53-3.83-2.66,3-2.44,5.66c.25,3.07,3.57,11.92,3.63,14.56S328.12,288.68,328.79,289.14Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M330.17,288.64c.4.42,2-.15,2.49-.23s.58-.85.56-1.14-.32-5.07-.26-9.16.64-7.33,0-9.78-2.15-4.29-3.52-3.68-1.69,2.9-1.55,5.43c.16,2.95,2.27,11.45,2.31,14S329.74,288.2,330.17,288.64Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M331.57,232.43a3.23,3.23,0,0,0-1.38,4.28,8.46,8.46,0,0,1,.8,4.67,26.75,26.75,0,0,1-1.07,2.76,5.32,5.32,0,0,0,3.42,1.14c1.73-.21,2.19-1,2.19-1S336.31,229.92,331.57,232.43Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M331.19,238.79a3.11,3.11,0,0,0,1.45,2.53c1.08.73,3,2.13,4.24,1.46s1.64-4.31,1.67-5.61-.33-3.85-2-4.8a4.7,4.7,0,0,0-3.34-.65,5.2,5.2,0,0,0-2.11,1.38c-.45.46,0,1.83.25,2.8A11.48,11.48,0,0,1,331.19,238.79Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M332.93,238.52A3,3,0,0,0,334,240.8c.78.65,2.16,1.91,3,1.31s1.19-3.87,1.21-5-.24-3.46-1.42-4.31a2.77,2.77,0,0,0-2.41-.58,3.71,3.71,0,0,0-1.52,1.24c-.33.41,0,1.64.18,2.51A12.71,12.71,0,0,1,332.93,238.52Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M329.84,261.08c1.2.06,5.66-1.94,6.82-2.72,1-.67,1.29-1.4,1.86-1.67a5.16,5.16,0,0,1,1.56-.25c.73-.16-.13-2.83-.16-3v0h0a.17.17,0,0,1,0-.07h0c0-.06,0-.13,0-.22l-.79.42a17.87,17.87,0,0,1-4.82,2c-2.21.52-3.73.12-5.06-2.43-.94-1.81-3.56-1.58-4.77-1.88h0c.09.4.56,2.56,1.09,4.16C326.28,257.47,327.06,261,329.84,261.08Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M336.85,255.9a26.18,26.18,0,0,0,3.27-1.71c-.1-.39-.19-.69-.2-.74a1.36,1.36,0,0,1,0-.34l-.79.42a17.87,17.87,0,0,1-4.82,2c-2.21.52-3.73.12-5.06-2.43-.94-1.81-3.56-1.58-4.77-1.88.09.4.56,2.56,1.09,4.16s1,3.65,2.29,4.84a4.55,4.55,0,0,0,.18-1.49,7.12,7.12,0,0,1,.7-4S330.29,259.32,336.85,255.9Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M322.19,276.75c-.53.12-.76.29-.71.81s0,2.38,0,3.18a9.47,9.47,0,0,0,.66,2.62,2.74,2.74,0,0,0,.35,1.11c.29.38.5.26.59.17s.07-.43,0-.63a8.21,8.21,0,0,1-.1-1.15l.45,1.77c.12.48.44,1,.75,1a.36.36,0,0,0,.4-.39,5.88,5.88,0,0,1-.3-1c0-.33,0-.85,0-.85a7.06,7.06,0,0,0,.41,1.75c.14.31.45,1.44,1,1.16s-.1-1.22-.18-1.51a10.53,10.53,0,0,1-.17-3.34c.11-.69.36-1,1-.38s1.26,1,1.41.64-.47-1.09-.86-1.56a8.22,8.22,0,0,0-1.56-1.34c-1-.6-1-1.7-1.6-2A2,2,0,0,0,322.19,276.75Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M322.19,276.75c-.53.12-.76.29-.71.81s0,2.38,0,3.18a9.47,9.47,0,0,0,.66,2.62,2.74,2.74,0,0,0,.35,1.11c.29.38.5.26.59.17s.07-.43,0-.63a8.21,8.21,0,0,1-.1-1.15l.45,1.77c.12.48.44,1,.75,1a.36.36,0,0,0,.4-.39,5.88,5.88,0,0,1-.3-1c0-.33,0-.85,0-.85a7.06,7.06,0,0,0,.41,1.75c.14.31.45,1.44,1,1.16s-.1-1.22-.18-1.51a10.53,10.53,0,0,1-.17-3.34c.11-.69.36-1,1-.38s1.26,1,1.41.64-.47-1.09-.86-1.56a8.22,8.22,0,0,0-1.56-1.34c-1-.6-1-1.7-1.6-2A2,2,0,0,0,322.19,276.75Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M323.7,276.84a1.13,1.13,0,1,1-1.22-1A1.12,1.12,0,0,1,323.7,276.84Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M321.25,261.68a2,2,0,0,0-1.16,1.33c-.34,1.07.58,11.15.75,12.15s.41,2.31,1.56,2.19,1.51-.79,1.48-1.5c-.05-.94-.12-5.74.1-8.64.2-2.68.14-3.68-.17-4.27S322.24,261.29,321.25,261.68Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M321.82,263.22a1.48,1.48,0,0,0-.75,1.1c-.21.89.55,9.38.67,10.22s.31,1.94,1.07,1.86a1,1,0,0,0,1-1.24c0-.79-.16-4.83-.06-7.26.09-2.24,0-3.09-.17-3.59S322.47,262.91,321.82,263.22Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M323.22,250.63a4.58,4.58,0,0,0,2,.63c.63,0,1.48.27,1.54.86s-.92.85-1.2,3.52-1.31,1.52-2.06-.34S322.87,251.17,323.22,250.63Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M323.53,262.55a1.47,1.47,0,1,1-1.1-1.76A1.47,1.47,0,0,1,323.53,262.55Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M320.84,261.06c0,.49.9.83,1.76,1.18s1.43.24,1.48-.21,1.05-4.14,1.5-5.45,1.37-2.56.65-3.25-2.74-2.39-3.68-1.91S320.83,260.42,320.84,261.06Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M322,260.64c0,.42.51.76,1,1.09s.89.26.95-.13.95-3.57,1.32-4.7,1.05-2.19.65-2.82-1.57-2.19-2.2-1.81S322,260.08,322,260.64Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M334.43,239.77c-.23-2,.12-5.52-1.36-6.47a2.39,2.39,0,0,0-2-.16c-.39.5.07,1.82.28,2.76a11.48,11.48,0,0,1-.19,2.89,3.11,3.11,0,0,0,1.45,2.53,9.18,9.18,0,0,0,3.08,1.59A8.19,8.19,0,0,1,334.43,239.77Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.93 198.41 113.03 144.99 85.67 127.76 0.56 181.19 27.93 198.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "2.13 165.69 2.13 183.58 0.1 182.3 0.1 164.41 2.13 165.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "2.13 165.69 2.13 183.58 4.15 182.3 4.15 164.42 2.13 165.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "4.15 164.42 2.13 165.69 0.1 164.41 2.13 163.14 4.15 164.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "113.16 113.31 82.49 93.81 82.49 125.69 113.16 145.2 113.16 113.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "115.96 111.56 115.96 146.94 113.16 145.16 113.16 113.31 82.49 93.81 82.49 125.66 79.69 123.88 79.69 88.5 115.96 111.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "84.8 124.26 82.49 125.69 82.49 93.81 84.8 95.27 84.8 124.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M329.89,346.31l85.3-53.62c2.77-1.74,5-6.43,5-10.46h0c0-4-2.25-5.88-5-4.14l-85.3,53.62c-2.77,1.74-5,6.43-5,10.46h0C324.87,346.2,327.12,348.05,329.89,346.31Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M386.62,274a3.53,3.53,0,0,0,1.24,3.06l22.95,14.47c.8.49.29-.61,1.5-1.38a10.83,10.83,0,0,0,4.41-8.3c0-1.5,1.28-1.52.5-2l-23.1-14.5a2.93,2.93,0,0,0-3.08.37A10.83,10.83,0,0,0,386.62,274Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M409.68,288.5c0,3.05,2,4.27,4.42,2.74a10.85,10.85,0,0,0,4.41-8.3c0-3.05-2-4.28-4.41-2.74A10.81,10.81,0,0,0,409.68,288.5Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-131",
    cx: 414.19,
    cy: 285.77,
    rx: 2.67,
    ry: 1.47,
    transform: "translate(-327.86 374.39) rotate(-63.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M413.88,280.08a3,3,0,0,1,3-.4,3.23,3.23,0,0,0-2.64.56,10.85,10.85,0,0,0-4.41,8.3c0,1.59.54,2.68,1.4,3.15-1.08-.33-1.78-1.5-1.78-3.31A10.83,10.83,0,0,1,413.88,280.08Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M376.22,280.56a3.51,3.51,0,0,0,1.23,3.05l22.95,14.48c.8.48.29-.62,1.5-1.38a10.82,10.82,0,0,0,4.41-8.3c0-1.51,1.28-1.52.5-2l-23.1-14.49a2.91,2.91,0,0,0-3.08.37A10.8,10.8,0,0,0,376.22,280.56Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M399.27,295.07c0,3.05,2,4.28,4.42,2.74a10.83,10.83,0,0,0,4.41-8.3c0-3.05-2-4.27-4.41-2.74A10.81,10.81,0,0,0,399.27,295.07Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-131",
    cx: 403.79,
    cy: 292.35,
    rx: 2.67,
    ry: 1.47,
    transform: "translate(-339.55 368.72) rotate(-63.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M403.48,286.65a3,3,0,0,1,3-.4,3.23,3.23,0,0,0-2.64.57,10.81,10.81,0,0,0-4.42,8.3c0,1.58.54,2.68,1.4,3.14-1.08-.32-1.78-1.49-1.78-3.31A10.83,10.83,0,0,1,403.48,286.65Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M365.81,287.13a3.5,3.5,0,0,0,1.24,3.06L390,304.66c.8.49.29-.62,1.5-1.38a10.8,10.8,0,0,0,4.41-8.3c0-1.51,1.28-1.52.5-2l-23.1-14.5a2.94,2.94,0,0,0-3.08.37A10.82,10.82,0,0,0,365.81,287.13Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M388.87,301.64c0,3.05,2,4.28,4.41,2.75a10.82,10.82,0,0,0,4.41-8.3c0-3-2-4.28-4.41-2.75A10.82,10.82,0,0,0,388.87,301.64Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-131",
    cx: 393.38,
    cy: 298.92,
    rx: 2.67,
    ry: 1.47,
    transform: "translate(-351.24 363.05) rotate(-63.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M393.07,293.23a3,3,0,0,1,3-.41,3.27,3.27,0,0,0-2.64.57,10.81,10.81,0,0,0-4.42,8.3c0,1.59.54,2.68,1.4,3.15-1.08-.33-1.78-1.5-1.78-3.31A10.81,10.81,0,0,1,393.07,293.23Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M355.4,293.71a3.5,3.5,0,0,0,1.24,3.05l22.94,14.47c.8.49.29-.61,1.5-1.37a10.84,10.84,0,0,0,4.42-8.3c0-1.51,1.27-1.52.49-2L362.89,285a2.92,2.92,0,0,0-3.08.38A10.83,10.83,0,0,0,355.4,293.71Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M378.46,308.22c0,3,2,4.28,4.41,2.74a10.8,10.8,0,0,0,4.41-8.3c0-3.05-2-4.28-4.41-2.74A10.8,10.8,0,0,0,378.46,308.22Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-131",
    cx: 382.97,
    cy: 305.5,
    rx: 2.67,
    ry: 1.47,
    transform: "translate(-362.92 357.38) rotate(-63.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M382.66,299.8a3,3,0,0,1,3-.4A3.22,3.22,0,0,0,383,300a10.82,10.82,0,0,0-4.41,8.3c0,1.59.53,2.68,1.39,3.15-1.08-.33-1.77-1.5-1.77-3.31A10.82,10.82,0,0,1,382.66,299.8Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M345,300.28a3.48,3.48,0,0,0,1.24,3.05l22.95,14.48c.79.48.28-.62,1.49-1.38a10.83,10.83,0,0,0,4.42-8.3c0-1.51,1.28-1.52.49-2l-23.09-14.5a2.91,2.91,0,0,0-3.08.37A10.81,10.81,0,0,0,345,300.28Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M368.05,314.79c0,3,2,4.28,4.41,2.75a10.84,10.84,0,0,0,4.42-8.3c0-3.05-2-4.28-4.42-2.75A10.82,10.82,0,0,0,368.05,314.79Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-131",
    cx: 372.56,
    cy: 312.07,
    rx: 2.67,
    ry: 1.47,
    transform: "translate(-374.61 351.71) rotate(-63.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M372.25,306.38a3,3,0,0,1,3-.41,3.27,3.27,0,0,0-2.64.57,10.8,10.8,0,0,0-4.41,8.3c0,1.59.53,2.68,1.39,3.15-1.08-.33-1.77-1.5-1.77-3.31A10.8,10.8,0,0,1,372.25,306.38Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M334.58,306.85a3.53,3.53,0,0,0,1.24,3.06l22.95,14.47c.79.49.28-.61,1.5-1.38a10.83,10.83,0,0,0,4.41-8.3c0-1.5,1.28-1.52.5-2l-23.1-14.5a2.93,2.93,0,0,0-3.08.37A10.83,10.83,0,0,0,334.58,306.85Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M357.64,321.37c0,3.05,2,4.27,4.41,2.74a10.83,10.83,0,0,0,4.42-8.3c0-3.05-2-4.28-4.42-2.74A10.83,10.83,0,0,0,357.64,321.37Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-131",
    cx: 362.15,
    cy: 318.64,
    rx: 2.67,
    ry: 1.47,
    transform: "translate(-386.3 346.04) rotate(-63.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M361.84,313a3,3,0,0,1,3-.4,3.23,3.23,0,0,0-2.64.56,10.85,10.85,0,0,0-4.41,8.3,3.38,3.38,0,0,0,1.39,3.15c-1.07-.33-1.77-1.5-1.77-3.31A10.8,10.8,0,0,1,361.84,313Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M324.18,313.43a3.51,3.51,0,0,0,1.23,3.05L348.36,331c.8.48.29-.62,1.5-1.38a10.82,10.82,0,0,0,4.41-8.3c0-1.51,1.28-1.52.5-2l-23.1-14.49a2.91,2.91,0,0,0-3.08.37A10.8,10.8,0,0,0,324.18,313.43Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M347.23,327.94c0,3.05,2,4.28,4.42,2.74a10.83,10.83,0,0,0,4.41-8.3c0-3.05-2-4.27-4.41-2.74A10.81,10.81,0,0,0,347.23,327.94Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-131",
    cx: 351.74,
    cy: 325.22,
    rx: 2.67,
    ry: 1.47,
    transform: "translate(-397.99 340.37) rotate(-63.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M351.43,319.52a3,3,0,0,1,3-.4,3.21,3.21,0,0,0-2.63.57,10.81,10.81,0,0,0-4.42,8.3c0,1.58.54,2.68,1.4,3.14-1.08-.32-1.78-1.49-1.78-3.31A10.85,10.85,0,0,1,351.43,319.52Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M313.77,320a3.5,3.5,0,0,0,1.24,3.06L338,337.53c.8.49.29-.62,1.5-1.38a10.8,10.8,0,0,0,4.41-8.3c0-1.51,1.28-1.52.5-2l-23.1-14.5a2.94,2.94,0,0,0-3.08.37A10.82,10.82,0,0,0,313.77,320Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M336.82,334.51c0,3.05,2,4.28,4.42,2.75a10.82,10.82,0,0,0,4.41-8.3c0-3-2-4.28-4.41-2.75A10.83,10.83,0,0,0,336.82,334.51Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-131",
    cx: 341.34,
    cy: 331.79,
    rx: 2.67,
    ry: 1.47,
    transform: "translate(-409.67 334.7) rotate(-63.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M341,326.1a3,3,0,0,1,3-.41,3.27,3.27,0,0,0-2.64.57,10.81,10.81,0,0,0-4.42,8.3c0,1.59.54,2.68,1.4,3.15-1.08-.33-1.78-1.5-1.78-3.31A10.81,10.81,0,0,1,341,326.1Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M303.36,326.58a3.5,3.5,0,0,0,1.24,3.05l22.94,14.47c.8.49.29-.61,1.5-1.37a10.84,10.84,0,0,0,4.41-8.3c0-1.51,1.28-1.52.5-2l-23.1-14.5a2.92,2.92,0,0,0-3.08.38A10.8,10.8,0,0,0,303.36,326.58Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M326.42,341.09c0,3.05,2,4.28,4.41,2.74a10.8,10.8,0,0,0,4.41-8.3c0-3-2-4.28-4.41-2.74A10.8,10.8,0,0,0,326.42,341.09Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-131",
    cx: 330.93,
    cy: 338.37,
    rx: 2.67,
    ry: 1.47,
    transform: "translate(-421.36 329.03) rotate(-63.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M330.62,332.67a3,3,0,0,1,3-.4,3.22,3.22,0,0,0-2.64.56,10.82,10.82,0,0,0-4.41,8.3c0,1.59.53,2.68,1.39,3.15-1.08-.33-1.78-1.5-1.78-3.31A10.83,10.83,0,0,1,330.62,332.67Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M307.3,317.49l85.3-53.62a3,3,0,0,1,3.38-.22l22.37,14.08a3.06,3.06,0,0,0-3.16.36l-85.3,53.62c-2.77,1.74-5,6.43-5,10.46h0c0,2.28.72,3.86,1.85,4.49l0,0-22.55-14.24c-1.13-.63-1.85-2.22-1.85-4.5h0C302.28,323.92,304.53,319.24,307.3,317.49Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "111.84 122.93 89.16 108.79 88.6 109.07 111.28 123.3 111.84 122.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "111.84 122.93 89.16 108.79 89.44 108.53 112.12 122.77 111.84 122.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "106.94 126.01 84.26 111.86 83.7 112.14 106.38 126.38 106.94 126.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "106.94 126.01 84.26 111.86 84.54 111.61 107.22 125.84 106.94 126.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "102.04 129.08 79.36 114.94 78.81 115.22 101.49 129.46 102.04 129.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "102.04 129.08 79.36 114.94 79.64 114.68 102.32 128.92 102.04 129.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "97.15 132.16 74.47 118.02 73.91 118.3 96.59 132.53 97.15 132.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "97.15 132.16 74.47 118.02 74.75 117.76 97.42 132 97.15 132.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "92.25 135.24 69.57 121.09 69.01 121.37 91.69 135.61 92.25 135.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "92.25 135.24 69.57 121.09 69.85 120.83 92.53 135.07 92.25 135.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "87.35 138.31 64.67 124.17 64.11 124.45 86.79 138.69 87.35 138.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "87.35 138.31 64.67 124.17 64.95 123.91 87.63 138.15 87.35 138.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "82.45 141.39 59.77 127.24 59.21 127.53 81.89 141.76 82.45 141.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "82.45 141.39 59.77 127.24 60.05 126.99 82.73 141.22 82.45 141.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "77.55 144.46 54.87 130.32 54.31 130.6 77 144.84 77.55 144.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "77.55 144.46 54.87 130.32 55.15 130.06 77.83 144.3 77.55 144.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "72.66 147.54 49.98 133.4 49.42 133.68 72.1 147.91 72.66 147.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "72.66 147.54 49.98 133.4 50.26 133.14 72.94 147.38 72.66 147.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "67.76 150.62 45.08 136.47 44.52 136.75 67.2 150.99 67.76 150.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "67.76 150.62 45.08 136.47 45.36 136.22 68.04 150.45 67.76 150.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "62.86 153.69 40.18 139.55 39.62 139.83 62.3 154.07 62.86 153.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "62.86 153.69 40.18 139.55 40.46 139.29 63.14 153.53 62.86 153.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "57.96 156.77 35.28 142.63 34.72 142.91 57.4 157.14 57.96 156.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "57.96 156.77 35.28 142.63 35.56 142.37 58.24 156.6 57.96 156.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "53.06 159.84 30.38 145.7 29.82 145.98 52.51 160.22 53.06 159.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "53.06 159.84 30.38 145.7 30.66 145.44 53.34 159.68 53.06 159.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "48.16 162.92 25.48 148.78 24.93 149.06 47.61 163.3 48.16 162.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "48.16 162.92 25.48 148.78 25.76 148.52 48.44 162.76 48.16 162.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "43.27 166 20.59 151.85 20.03 152.13 42.71 166.37 43.27 166"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "43.27 166 20.59 151.85 20.87 151.6 43.55 165.83 43.27 166"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "38.37 169.07 15.69 154.93 15.13 155.21 37.81 169.45 38.37 169.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "38.37 169.07 15.69 154.93 15.97 154.67 38.65 168.91 38.37 169.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "33.47 172.15 10.79 158.01 10.23 158.29 32.91 172.53 33.47 172.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "33.47 172.15 10.79 158.01 11.07 157.75 33.75 171.99 33.47 172.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "28.57 175.23 5.89 161.08 5.33 161.36 28.01 175.6 28.57 175.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "28.57 175.23 5.89 161.08 6.17 160.83 28.85 175.06 28.57 175.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M324.87,342.17h0c0,4,2.25,5.88,5,4.14l85.3-53.62c2.77-1.74,5-6.43,5-10.46h0c0-4-2.25-5.88-5-4.14l-85.3,53.62C327.12,333.45,324.87,338.14,324.87,342.17Zm1,0c0-3.61,2.06-7.95,4.51-9.49l85.3-53.61a2.77,2.77,0,0,1,1.47-.51c1.48,0,2,2,2,3.67,0,3.61-2.06,7.95-4.51,9.49l-85.29,53.61a2.83,2.83,0,0,1-1.48.51C326.42,345.84,325.9,343.86,325.9,342.17Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "24.81 178.94 2.13 164.79 1.87 165.26 24.55 179.5 24.81 178.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "24.81 178.94 2.13 164.79 2.33 164.5 25.01 178.74 24.81 178.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "22.85 184.31 0.17 170.17 0.09 170.74 22.77 184.98 22.85 184.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "22.85 184.31 0.17 170.17 0.23 169.82 22.91 184.06 22.85 184.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "115.94 111.56 115.94 146.94 118.26 145.51 118.26 110.16 115.94 111.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "118.26 110.16 115.94 111.56 79.69 88.5 82.05 87.07 118.26 110.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "29.3 182.89 29.3 200.78 27.26 199.5 27.26 181.62 29.3 182.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "29.29 182.89 29.29 200.78 31.31 199.5 31.31 181.62 29.29 182.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "31.31 181.62 29.29 182.89 27.26 181.62 29.29 180.34 31.31 181.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M349.26,301.73c10,7.37,24.56,5.89,30.5-16.23L371,295.34Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M360.13,296c-.48,1.48-1,2.82-1.48,4,7-2.17,13.08-4.51,15.67-6.75s3.56-4.9,4.63-7.63C368.15,285.55,363.38,286,360.13,296Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M361.37,298.05c-4,1.26-8.38,2.44-12.35,3.49",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M408.25,263.25c-.15-.07-.29-.15-.43-.23-3.61-1.35-7.19-2.13-8.3,1.32-.44,1.35-.78,4.69-1.74,8.34a17.86,17.86,0,0,0,7.61-5.3l5.21-3.25-1.2-.49A6.77,6.77,0,0,1,408.25,263.25Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M386.34,275.87c-4.65,3-6.09,6.4-7.39,9.72,2,0,4.19,0,6.62,0,10.05-.05,14-8.29,15.9-15.48C396.63,272,391.49,272.59,386.34,275.87Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M408.25,263.25a6.09,6.09,0,0,1-2.93-3.07c-1,3-3.1,5.17-7,6.31-7.42,2.19-15.08-1.48-20,7.49a108.13,108.13,0,0,0-5,11.3c-1.32,3.27-4.07,8-7.93,10.17-4.41,2.5-9.31,1.47-12.81.24-3.77-1.32-8.41-4.11-13.83-.67a19.93,19.93,0,0,0-3.54,3.11,17.66,17.66,0,0,1-3.59,3.07c-2.29,1.36-3.78.9-5.54.36a3.6,3.6,0,0,0-2.67.1,4.29,4.29,0,0,0-2.2,3.53c-.31,2.89.49,5.67,2.94,7a8.22,8.22,0,0,0,6.29.16c2.76-.94,4.09-3,6.29-4.8a39.52,39.52,0,0,1,21.85-8.19c3.42-.2,6.95.12,10.38-1.62s5.72-5.1,7.23-8.15,2.73-6.28,5.42-9c5.54-5.55,14.5-6.41,21.16-11a24.75,24.75,0,0,0,6.13-6.12A6.61,6.61,0,0,1,408.25,263.25Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M326.13,301.56a3.45,3.45,0,0,0-4.41,1.93l5.18,3.27a120.16,120.16,0,0,0,13.72-3c1.38-.37,3-.78,4.71-1.22,1.1-.47,2.21-.89,3.33-1.25-6.51-5.21-10.19-4.33-16.5-.36l-.49.31C329.38,302.56,327.89,302.1,326.13,301.56Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M408.25,263.25a5.63,5.63,0,0,1-2.37-2.08,22.66,22.66,0,0,1-1.1,4.74,10.44,10.44,0,0,1-3.8,4.71c-5.45,3.62-11.37,1-17.17,4.35-6.2,3.57-7.1,9.18-10.5,14-3.69,5.25-9.42,8.12-15.55,9.86-3.06.87-6.06,1.54-9.14,2.4l-.07,0a63.5,63.5,0,0,1-12.43,2.4c-3.93.26-7.57-.17-10.48-1.8a2.06,2.06,0,0,0-2.26-.15,1.7,1.7,0,0,0-.55,2,19.24,19.24,0,0,0,4.41,7.87c.11.13.24.26.36.39l.38.37a4.58,4.58,0,0,0,3.85,1.59c3.16-.37,4.95-3.38,6.51-5.56l.09-.12a16.34,16.34,0,0,1,10.83-6.48,80.68,80.68,0,0,1,9.24-.9c4.13-.31,8.37.15,13.12-2.85,5.75-3.63,7.39-14,12-18.33a20.79,20.79,0,0,1,7.63-4.31c4.68-1.59,9.69-2.46,13.69-6a25.08,25.08,0,0,0,4.61-5.64A6.7,6.7,0,0,1,408.25,263.25Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M404.92,269.31a21.77,21.77,0,0,0,2.57-2.71c-21.55,2-22,5-29.27,22.14h0c1.64-3.47,3.17-7,5.39-9.09a20.79,20.79,0,0,1,7.63-4.31C395.92,273.75,400.93,272.88,404.92,269.31Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M349.26,301.73a16.34,16.34,0,0,0-10.83,6.48l-.09.12c-1.56,2.18-3.35,5.19-6.51,5.56A4.58,4.58,0,0,1,328,312.3c-.13-.12-.26-.24-.38-.37l-.36-.39c-.24-.26-.47-.52-.7-.79,2.6-1.64,6-4.71,9.58-7.1l1-.63c3.89-2.42,7.95-3.87,11.47-1.77A7.39,7.39,0,0,1,349.26,301.73Z",
    transform: "translate(-302.28 -155.96)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "115.96 111.56 115.96 146.94 113.16 145.16 113.16 113.31 82.49 93.81 82.49 110.94 79.69 109.17 79.69 88.5 115.96 111.56"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelSeparation);
export default __webpack_public_path__ + "static/media/channel-separation.cebee1850c47720e88fade51d99fbef4.svg";
export { ForwardRef as ReactComponent };